import React, { useState } from 'react';
import { Card, CardContent, useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { t } from '../../i18n';
import RegisterForm from './components/Register.form';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton.component';
import Routes from '../Navigator/Navigator.route';
import {
  useStyles,
  CenterRow,
  Header,
  CardWrapper,
  CardTitle,
  TextCenter,
  ButtonBackWrapper,
  ButtonBackToSignIn
} from './Register.style';
import MainLogo from 'src/components/MainLogo/MainLogo';
import { parseJSON } from 'src/utils/common.util';

const RegisterView: React.FC = () => {
  const classes = useStyles();
  const [isRegisterSuccessful, setRegisterSuccessful] = useState<boolean>(
    false
  );
  const history = useHistory();

  const handleBackToSignIn = () => {
    history.push(Routes.SignIn);
  };

  const matches = useMediaQuery('(max-width:768px)')
  const isIpadLg = useMediaQuery('(max-width:1024px)')

  const isTablet = matches || isIpadLg


  return (
    <div>
      <Header>
        <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
      </Header>
      {!isRegisterSuccessful && (
        <div style={{ paddingLeft: '10%' }}>
          <ButtonBackToSignIn onClick={handleBackToSignIn}>
            ← {t('register.successful.buttonBack')}
          </ButtonBackToSignIn>
        </div>
      )}
      <CardWrapper>
        {isRegisterSuccessful ? (
          <Card className={classes['card-success']}>
            <CardContent>
              <CardTitle>{t('register.successful.title')}</CardTitle>
              <TextCenter className={classes.mb30}>
                {t('register.successful.description')}
              </TextCenter>
              <CenterRow>
                <ButtonBackWrapper>
                  <PrimaryButton
                    onClick={handleBackToSignIn}
                    variant="contained"
                    isShowIcon={false}
                    title={t('register.successful.buttonBack')}
                  />
                </ButtonBackWrapper>
              </CenterRow>
            </CardContent>
          </Card>
        ) : (
          <Card className={isTablet ? classes['width80%'] : classes['width30%']}>
            <CardContent>

              <CardTitle>{t('register.title')}</CardTitle>
              <RegisterForm setRegisterSuccessful={setRegisterSuccessful} />
            </CardContent>
          </Card>
        )}
      </CardWrapper>
    </div>
  );
};

export default RegisterView;
